// extracted by mini-css-extract-plugin
export default {"messageContainer":"LogoutModal_messageContainer__7NWdv","subMessage":"LogoutModal_subMessage__4s4RC","sessionMessage":"LogoutModal_sessionMessage__WIYRC"};